var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"more-button",attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"more-button__text",class:{ 'more-button__text--loading': _vm.isLoading }},[_vm._v("\n        "+_vm._s(_vm.isLoading ? 'Загрузка...' : 'Еще')+"\n        "),(!_vm.isLoading)?_c('IconCircleArrows'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }